import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { emailValidation } from 'validators';
import { Button, TextField, Typography, useIsMounted } from 'seagull';
import commonStyles from '~/components/ChangeEmailAddressModal/ChangeEmailAddress.module.scss';
import { changeEmailErrorMessages, ViewType } from '~/components/ChangeEmailAddressModal/ChangeEmailAddressTypes';
import { useLocaleKeys } from '~/i18n';
import { ServerError } from '~/infra/ErrorResponse';
import { handleRequest } from '~/infra/utils';
import { useStoreActions } from '~/store/store-context';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
const SetUpNewEmail = (param)=>{
    let { onClose, handleSetView, handleSetNewEmail } = param;
    const { t: texts } = useLocaleKeys('components.changeEmailModal');
    const { api } = useStoreActions();
    const [isLoading, setIsLoading] = useState(false);
    const isMounted = useIsMounted();
    const { control, formState, handleSubmit, setError } = useForm({
        mode: 'onChange',
        defaultValues: {
            newEmail: ''
        }
    });
    const handleSetUpNewEmail = async (newEmail)=>{
        handleSetView(ViewType.VerifyNewEmail);
        handleSetNewEmail(newEmail);
        setIsLoading(false);
        return;
    };
    const handleError = (error)=>{
        if (error.hasServerError(ServerError.EmailAlreadyRegistered)) {
            setError('newEmail', {
                message: changeEmailErrorMessages.emailAlreadyRegistered
            });
            return;
        }
        if (error.isTooManyAttemptsError()) {
            handleSetView(ViewType.TooManyAttempts);
            return;
        }
        setError('newEmail', {
            message: changeEmailErrorMessages.somethingWentWrong
        });
    };
    const sendNewEmail = async (param)=>{
        let { newEmail } = param;
        setIsLoading(true);
        const changeEmailResult = await handleRequest(api.user.changeUserEmail({
            email: newEmail
        }));
        if (changeEmailResult.success) {
            await handleSetUpNewEmail(newEmail);
        } else {
            handleError(changeEmailResult.error);
        }
        if (isMounted()) {
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "set-up-new-email-address-view",
        children: /*#__PURE__*/ _jsxs("form", {
            onSubmit: handleSubmit(sendNewEmail),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: commonStyles.content,
                    children: [
                        /*#__PURE__*/ _jsxs(Typography, {
                            variant: "paragraph1",
                            testId: "set-up-new-email-info-text",
                            children: [
                                "To verify your new email address, we’ll send you a confirmation email ",
                                /*#__PURE__*/ _jsx("br", {}),
                                " containing a one-time code."
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Controller, {
                            control: control,
                            name: "newEmail",
                            rules: emailValidation(undefined, {
                                required: true
                            }),
                            render: (p)=>/*#__PURE__*/ _jsx(TextField, _object_spread({
                                    bi: {
                                        name: 'new_email'
                                    },
                                    collapseHelperText: false,
                                    width: 360,
                                    testId: "set-up-new-email-address",
                                    type: "email",
                                    label: texts.newEmailLabel()
                                }, connectControllerToTextField(p)))
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: commonStyles.footer,
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            bi: {
                                name: 'cancel_set_up_new_email'
                            },
                            onClick: onClose,
                            skin: "primaryOutlineOpaque",
                            testId: "set-up-new-email-cancel-button",
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            bi: {
                                name: 'send_set_up_new_email_code'
                            },
                            type: "submit",
                            testId: "set-up-new-email-send-code-button",
                            disabled: !formState.isValid,
                            loading: isLoading,
                            children: "Send code"
                        })
                    ]
                })
            ]
        })
    });
};
export default SetUpNewEmail;
